import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import Product from 'PMT/entities/menu/Product';

class ProductOptionProductRow extends Component {

  static propTypes = {
    product: PropTypes.instanceOf(Product).isRequired
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.product.equals(this.props.product);
  }

  onDisplayDetailClick = () => {
    RouteAction.presentProductEdit(this.product);
  };

  get product(): Product {
    return this.props.product;
  }

  // -- renderers

  render() {
    return (
      <li
        onClick={this.onDisplayDetailClick}
      >
        <h4 className="link-hover">
          {this.product.name}
        </h4>
      </li>
    );
  }

}

export default ProductOptionProductRow;
